import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { ILogin } from "../../models/Login";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { IDocumentMastDropdown } from "../../models/IDropdown";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { PODocType } from "../../models/FDropdown";
import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { safeFormatDate } from "../../models/DateFormatMapper";
import LegalTaskHistory from "./LegalTaskHistory";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { IPurchaseOrder } from "../../models/PurchaseOrder";

interface IProps {
  open: boolean;
  type: string;
  hideDialog: () => void;
  hideDialogAb: () => void;
  pO_ID?: number;
  req_Id?: number;
  is_form: boolean;
  toast: any;
  sourceType: string;
}

interface ILegalTask {
  task_Id?: number;
  others?: string,
  task_Name?: string;
  document_Type?: string;
  document_Name?: string;
  priorty?: string;
  priority?: number;
  status?: string;
  assignedTo?: string;
  assignedBy?: string;
  created_At?: string;
  description?: string;
}

interface IStatusForm {
  status: string | null;
}

const schema = yup.object({
  task_Id: yup.number().required("Task Name is required"),
  others: yup.string().nullable(),
  document_Type: yup.string().required("Document Type is required"),
  document_Name: yup.string().required("Document Name is required"),
  priorty: yup.number().required("Priority is required").typeError("Priority is required"),
});

const statusSchema = yup.object({
  status: yup.string().required("Status is required"),
});

export const LegalTask = (props: IProps) => {
  const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>([]);
  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState<ILegalTask[]>([]);
  const [statusModal, setStatusModal] = useState({ open: false, row: null as any });
  const [historyModal, setHistoryModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
  const [supportiveDoc, setSupportiveDoc] = useState<File | any | null>(null);
  const [supportiveDocText, setSupportiveDocText] = useState<string>("");
  const [description, setDescription] = useState("");
  const [descriptionDialog, setDescriptionDialog] = useState({ visible: false, description: "" });
  const [taskOptions, setTaskOptions] = useState<any[]>([]);

  const onHide = () => {
    reset({
      task_Name: "",
      document_Name: "",
      priority: undefined,
      document_Type: defaultDocumentType,
    });

    resetStatus({
      status: "",
    });

    setTaskList([]);
    setLoading(false);
    setStatusModal({
      open: false,
      row: null,
    });

    props.hideDialog();
  };
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;
  const roles = loginObj.roles.map((r: any) => r.role_ID);
  const defaultDocumentType = roles.includes(2) || roles.includes(5) ? "Client" : roles.includes(3) || roles.includes(4) ? "Vendor" : "";

  const { control, handleSubmit, reset, watch, formState: { errors }, } = useForm<ILegalTask>({
    resolver: yupResolver(schema),
    defaultValues: {
      document_Type: props.type,
      task_Name: "",
      document_Name: "",
      priorty: "",
    },
    shouldFocusError: false
  });

  const { control: statusControl, handleSubmit: handleStatusSubmit, setValue: setStatusValue, reset: resetStatus, } = useForm<IStatusForm>({
    resolver: yupResolver(statusSchema),
    defaultValues: { status: "" },
    shouldFocusError: false
  });

  const loadDocuments = async (type: string) => {
    const response = await Fetch("Dropdown/document", "GET", null, null, null);
    if (response) {
      const data = await response.json();
      if (type === "Client") {
        setDocuments(data.filter((d: IDocumentMastDropdown) => d.document_Name.includes("Client")));
      }
      if (type === "Vendor") {
        setDocuments(data.filter((d: IDocumentMastDropdown) => d.document_Name.includes("Vendor")));
      }
      if (type === "Consultant") {
        setDocuments(data.filter((d: IDocumentMastDropdown) => !d.document_Name.includes("Client") && !d.document_Name.includes("Vendor")));
      }
    }
  };

  const loadTaskNames = async () => {
    const response = await Fetch("Legal_Task/taskDropdown", "GET", null, null, props.toast);

    if (response && response.ok) {
      const data = await response.json();
      setTaskOptions(data);
    }
  };
  const documentType = watch("document_Type");

  useEffect(() => {
    if (documentType) {
      loadDocuments(documentType);
    }
  }, [documentType]);

  const onSubmit = async (data: ILegalTask) => {
    setLoading(true);
    const selectedTask = taskOptions.find((x) => x.task_Id === data.task_Id);

    try {
      const bodypayload = {
        sourceType: props.sourceType,
        pO_ID: (props.sourceType !== "PO") ? null : props.pO_ID,
        req_Id: (props.sourceType !== "REQ") ? null : props.req_Id,
        task_Id: data.task_Id,
        task_Name: selectedTask?.task_Name,
        document_Type: data.document_Type,
        document_Name: data.document_Name,
        priority: data.priorty,
        description: description,
        Others: (props.sourceType !== "OTHER") ? null : data.others
      };

      const response = await Fetch("Legal_Task/legalPost", "POST", bodypayload, null, props.toast);

      if (response && response.ok) {
        // const savedTask: ILegalTask = await response.json();
        // setTaskList((prev) => [...prev, savedTask]);
        await loadTasks();
        setDescription("");
        props.hideDialogAb();
        reset({
          task_Name: "",
          document_Name: "",
          priorty: "",
          document_Type: watch("document_Type"),
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const PriorityOptions = [
    { name: "Low", value: 1 },
    { name: "Medium", value: 2 },
    { name: "High", value: 3 },
  ];

  const StatusOptions = [
    // { name: "Assigned", value: "Assigned" },
    // { name: "Pending", value: "Pending" },
    { name: "Received", value: "Received" },
    { name: "Under Review", value: "Under Review" },
    { name: "Fizzled Out", value: "Fizzled Out" },
    { name: "Negotiation in Progress", value: "Negotiation in Progress" },
    { name: "Documentation Pending", value: "Documentation Pending" },
    { name: "Executed", value: "Executed" },
    { name: "Escalated", value: "Escalated" },
    { name: "Completed", value: "Completed" },
    { name: "Approved", value: "Approved" },
    { name: "Rejected", value: "Rejected" },
    { name: "Closed", value: "Closed" },
  ];
  const saveStatus = async (data: IStatusForm) => {
    // if (data.status === statusModal.row?.status) {
    //   props.toast.current.show({
    //     severity: "warn",
    //     summary: "Warning",
    //     detail: "Please select a different status",
    //   });
    //   return;
    // }
    // const response = await Fetch(
    //   "Legal_Task/updateStatus",
    //   "PUT",
    //   {
    //     task_Id: statusModal.row?.task_Id,
    //     status: data.status,
    //   },null,props.toast,
    // );

    // if (response && response.ok) {
    //   setTaskList((prev) => prev.map((task) => (task === statusModal.row ? { ...task, status: data.status } : task)));
    // }
    const formData = new FormData();
    formData.append("spDoc", supportiveDoc);
    const forBody: any = { ...data, Task_Id: statusModal.row?.task_Id, supportive_Text: supportiveDocText };
    formData.append("body", JSON.stringify(forBody));
    const params = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
      body: formData,
    };

    const response = await fetch(`${baseUrl}Legal_Task/updateStatus`, params);

    if (response.status === 400) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      return;
    }

    if (response.ok) {
      props.toast.current.show({ severity: "success", detail: "Status Updated Successfully", life: 3000 });
      setStatusModal({ open: false, row: null });
      resetStatus();
      setSupportiveDoc(null);
      setSupportiveDocText("");
      loadTasks();
    }

    setStatusModal({ open: false, row: null });
    resetStatus();
  };

  const loadTasks = async () => {
    setLoading(true);
    try {
      const query = props.pO_ID ? `poId=${props.pO_ID}` : props.req_Id ? `reqId=${props.req_Id}` : "";
      const response = await Fetch("Legal_Task/LegalTask", "GET", null, query, props.toast);
      if (response && response.ok) {
        const data = await response.json();
        setTaskList(data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(1);
    if ((props.pO_ID || props.req_Id) && props.is_form === false) {
      console.log(2);
      loadTasks();
    }
    if (props.open) {
      console.log(3);
      reset({ document_Type: props.type, task_Name: "", document_Name: "", priorty: "" });
      loadDocuments(props.type);
      loadTaskNames();
    }
  }, [props.open, props.pO_ID, props.req_Id, props.type, props.is_form]);

  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (event.files[0].size > 1024000) {
      props.toast.current.show({ severity: "error", content: "Document should be less than 2 MB." });
      event.options.clear();
    } else {
      const file = event.files[0];
      setSupportiveDoc(file);
    }
  };

  const priorityLabel = (val: number | undefined) => {
    return PriorityOptions.find((p: any) => p.value === val)?.name ?? val ?? "";
  };
  const openHistory = (taskId: number) => {
    setSelectedTaskId(taskId);
    setHistoryModal(true);
  };
  return (
    <>
      {/* <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Edit Legal Document" modal className="p-fluid" onHide={onHide}> */}
      <form onSubmit={handleSubmit(onSubmit)} className="card p-fluid formgrid grid align-items-end">
        {props.sourceType === "OTHER" && <JVInput required column={3} label="Legal Task For" placeholder="Enter Legal Task Creating For" control={control} name="others" error={errors.others?.message} />}
        <JVDropdown required column={4} label="Task Name" control={control} name="task_Id" options={taskOptions} optionLabel="task_Name" optionValue="task_Id" />

        <JVDropdown required column={4} label="Document Type" control={control} name="document_Type" options={PODocType} optionLabel="name" optionValue="name" />

        <JVDropdown required column={4} label="Document Name" control={control} name="document_Name" options={documents} optionLabel="document_Name" optionValue="document_Name" error={errors.document_Name?.message} />

        <JVDropdown required column={4} label="Priority" control={control} name="priorty" options={PriorityOptions} optionLabel="name" optionValue="value" error={errors.priorty?.message} />

        <div className="field col-12">
          <label>Description</label>
          <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter task description" />
        </div>

        <div className="field col-12 md:col-4">
          <label>&nbsp;</label>
          <div className="flex gap-2">
            <Button loading={loading} label="Add" type="submit" />
            <Button
              label="Clear"
              type="button"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => {
                setDescription("");
                reset({
                  task_Name: "",
                  document_Name: "",
                  priorty: "",
                  document_Type: watch("document_Type"),
                });
              }}
            />
          </div>
        </div>
      </form>

      {props.is_form === false && <>
        <DataTable className="mt-2" style={{ border: "1px solid rgba(105,105,105,0.5)", borderTopWidth: "0" }} size="small" value={taskList} header="Legal Task List" showGridlines stripedRows loading={loading}>
          <Column header="SN" body={(_: any, options: any) => options.rowIndex + 1} />
          <Column field="task_Name" header="Name" />
          <Column
            header="Description"
            body={(rowData: any) =>
              rowData.description ? (
                <i className="pi cursor-pointer underline" style={{ color: "var(--primary-color)" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData?.description || "" })}>
                  View Description
                </i>
              ) : (
                "-"
              )
            }
          />
          <Column field="assignedTo" header="Assigned To" />
          <Column field="document_Type" header="Document Type" />
          <Column field="document_Name" header="Document Name" />
          <Column
            header="Status"
            body={(rowData: any) => {
              if (rowData?.status === "Closed") return <p onClick={() => props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Closed" })}>{rowData?.status || ""}</p>;
              if ((rowData?.status === "Escalated" || rowData?.status === "Completed") && !(roles.includes(1) || roles.includes(26))) {
                return (
                  <p
                    onClick={() =>
                      props.toast.current.show({
                        severity: "warn",
                        summary: "Warning",
                        detail: "Only Management can do changes now",
                      })
                    }
                  >
                    {rowData?.status}
                  </p>
                );
              }

              if (rowData?.status === "Created" && rowData?.assigned_To !== undefined && rowData?.assigned_To !== null) return <b>Waiting For Assigne For Acceptance</b>;

              if (rowData?.status !== "Pending") return <b>{rowData?.status}</b>;

              if (rowData?.assignedTo === undefined || rowData?.assignedTo === null || rowData?.assignedTo === "") {
                return <p>Task Created, Not Yet Assigned</p>;
              }

              if (!rowData?.assignee_Action_Status === true) return <b>{"Assigned"}</b>;

              if (!rowData?.assigned_To !== undefined || rowData?.assigned_To !== null) return <b>Waiting For Assigne For Acceptance</b>;

              if (rowData?.assigned_To === undefined || rowData?.assigned_To === null) {
                return <b>Created</b>;
              }

              if (rowData?.status === "Pending") {
                return <b>Waiting For Assignee For Acceptance</b>;
              }
              return (
                <span className=" text-black-700 ">
                  {rowData?.status}
                </span>
              );
            }}
          />
          <Column field="priority" header="Priority" body={(row) => priorityLabel(row.priority)} />
          <Column field="assignedBy" header="Assigned By" />
          <Column field="created_At" header="Created At" body={(rowData: any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat, true)} />
          <Column field="created_By" header="Created By" />
          <Column
            header="History"
            body={(rowData) => (
              <span className="cursor-pointer" onClick={() => openHistory(rowData.task_Id)}>
                <i className="pi pi-history" style={{ color: "var(--primary-color)" }} />
              </span>
            )}
          />
        </DataTable>

        <Dialog
          visible={statusModal.open}
          header="Update Status"
          style={{ width: "50vw" }}
          modal
          onHide={() => {
            setStatusModal({ open: false, row: null });
            resetStatus();
            setSupportiveDoc(null);
            setSupportiveDocText("");
          }}
        >
          <form onSubmit={handleStatusSubmit(saveStatus)}>
            <div className="p-fluid formgrid grid">
              <JVDropdown
                column={2}
                label="Status"
                control={statusControl}
                name="status"
                options={roles.includes(1) || roles.includes(26) ? StatusOptions : statusModal.row?.status === "Approved" ? StatusOptions.filter((el: any) => el.name === "Closed") : StatusOptions.filter((fl: any) => fl.name !== "Approved" && fl.name !== "Rejected")}
                optionLabel="name"
                optionValue="value"
                error={errors.status?.message}
              />
              <div className="field col-12 md:col-6">
                <label htmlFor="file">Supportive Document</label>
                <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} />
              </div>
              <div className="field col-12 md:col-12">
                {/* <label htmlFor="file">Supportive Reason<span style={{ color: 'red' }}>*</span></label> */}
                <label htmlFor="file">Supportive Reason</label>
                <InputTextarea value={supportiveDocText} onChange={(e) => setSupportiveDocText(e.target.value)} rows={5} cols={30} />
              </div>
              <div className="field col-12 flex justify-content-end gap-2">
                <Button label="Save" icon="pi pi-check" type="submit" />
                <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={() => resetStatus({ status: "" })} />
              </div>
            </div>
          </form>
        </Dialog>

        <LegalTaskHistory
          visible={historyModal}
          taskId={selectedTaskId}
          toast={props.toast}
          onHide={() => {
            setHistoryModal(false);
            setSelectedTaskId(null);
          }}
        />
        {/* Description Box */}
        <Dialog header="Task Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
          <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
        </Dialog>
      </>}
    </>
  );
};
